/**
 * Legacy ComboApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.comboApi`) keep resolving.
 *
 * The actual ComboApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/combo/combo-api.service.ts
 */
angular.module("acme.common.service.comboApi", [
  "acme.common.factory.QueryStringBuilder",
]);
